import React from 'react';
import testimonialBg from '../assets/images/testimonial-bg.jpg';

const TestimonialSection: React.FC = () => {
  return (
    <section className="bg-appbg px-6 pb-6 pt-8 lg:px-20">
      <div className="mx-auto max-w-[1728px] overflow-hidden rounded-[18px]">
        <div
          className="relative px-6 py-16 text-center sm:px-10"
          // style={{
          //   backgroundImage:
          //     `linear-gradient(rgba(230,241,245,0.82), rgba(230,241,245,0.82)), url('${testimonialBg}')`,
          //   backgroundSize: 'cover',
          //   backgroundPosition: 'center'
          // }}
          style={{
            backgroundImage: `linear-gradient(rgba(0,58,82,0.75), rgba(0,58,82,0.75)), url('${testimonialBg}')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        >
          <h2 className="text-[24px] font-extrabold tracking-[-0.02em] text-primary-100">
            The intersection of precision and people.
          </h2>
          <p className="mx-auto mt-5 max-w-[980px] text-[20px] italic leading-[1.45] tracking-[-0.01em] text-primary-50 sm:text-[18px]">
            &quot;FlintPay transformed our travel culture. It&apos;s the first time our employees actually enjoy
            reporting their expenses because they don&apos;t have to.&quot;
          </p>
          <div className="mx-auto mt-7 h-[4px] w-28 rounded-full bg-primary-600" />
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;
